"use client";

import { Info } from "lucide-react";
import { useTranslations } from "next-intl";
import { cn, HStack, Text } from "@/ui";

interface TryOnReferenceNoteProps {
  className?: string;
  compact?: boolean;
}

export function TryOnReferenceNote(props: TryOnReferenceNoteProps) {
  const { className, compact = false } = props;
  const t = useTranslations("virtual_try_on");

  return (
    <HStack
      role="note"
      className={cn("items-start gap-2 text-muted-foreground", className)}
    >
      <Info
        className="mt-0.5 size-3.5 shrink-0 opacity-70"
        aria-hidden
      />
      <Text className={cn("leading-relaxed", compact ? "text-[10px]" : "text-xs")}>
        {t("reference_note")}
      </Text>
    </HStack>
  );
}
